import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './CarouselWithDots.css';

import image1 from '../assets/image1.JPG';
import image2 from '../assets/image2.JPG';
import image3 from '../assets/image3.JPG';

const CarouselWithDots = () => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleChange = (index) => {
        setSelectedIndex(index);
    };

    return (
        <div className="carousel-container">
            <Carousel
                selectedItem={selectedIndex}
                onChange={handleChange}
                showThumbs={false}
                showStatus={false}
                showArrows={false}
                infiniteLoop
                autoPlay
                interval={5000}
                swipeable
                emulateTouch
            >
                <div className="carousel-slide">
                    <img src={image1} alt="Product 1" />
                </div>
                <div className="carousel-slide">
                    <img src={image2} alt="Product 2" />
                </div>
                <div className="carousel-slide">
                    <img src={image3} alt="Product 3" />
                </div>
            </Carousel>

            <div className="carousel-dots">
                {[0, 1, 2].map((index) => (
                    <button
                        key={index}
                        className={`dot ${selectedIndex === index ? 'active' : ''}`}
                        onClick={() => setSelectedIndex(index)}
                    ></button>
                ))}
            </div>
        </div>
    );
};

export default CarouselWithDots;
